import { AuditStdImport, ImportResults, Property } from '../../main/rate-audit/ra-create/utilities/auditstd-import-model';

export interface AuditStd_StandardAuditProperties{
  Address: string,
  AmadeusChainCode: string,
  AmadeusPropCode: string,
  ApolloChainCode: string,
  ApolloPropCode: string,
  AuditPropertyID: string,
  City: string,
  ContactEMail: string,
  ContactName: string,
  CountryCode: string,
  CurrencyFormatCode: string,
  CurrencyFormatID: number,
  GalileoChainCode: string,
  GalileoPropCode: string,
  HotelCRSCode: string,
  Name: string,
  PostalCode: string,
  SabreChainCode: string,
  SabrePropCode: string,
  Season1EndDate: any ,
  Season1ExpectedPrice?: number,
  Season1StartDate: any,
  Season2EndDate: any,
  Season2ExpectedPrice?: number,
  Season2StartDate: any,
  Season3EndDate: any,
  Season3ExpectedPrice?: number,
  Season3StartDate: any,
  Season4EndDate: any,
  Season4ExpectedPrice?: number,
  Season4StartDate: any,
  Season5EndDate: any,
  Season5ExpectedPrice?: number,
  Season5StartDate: any,
  Season6EndDate: any,
  Season6ExpectedPrice?: number,
  Season6StartDate: any,
  StateProvince: string,
  WorldspanChainCode: string,
  WorldspanPropCode: string,

  Season1StartDateString: string,
  Season1EndDateString: string,
  Season2StartDateString: string,
  Season2EndDateString: string,
  Season3StartDateString: string,
  Season3EndDateString: string,
  Season4StartDateString: string,
  Season4EndDateString: string,
  Season5StartDateString: string,
  Season5EndDateString: string,
  Season6StartDateString: string,
  Season6EndDateString: string,

  Season1StartDateCST:string,
  Season1EndDateCST:string,
  Season2StartDateCST:string,
  Season2EndDateCST:string,
  Season3StartDateCST:string,
  Season3EndDateCST:string,
  Season4StartDateCST:string,
  Season4EndDateCST:string,
  Season5StartDateCST:string,
  Season5EndDateCST:string,
  Season6StartDateCST:string,
  Season6EndDateCST:string,

  Season1ExpectedPriceDefault:string,
  Season2ExpectedPriceDefault:string,
  Season3ExpectedPriceDefault:string,
  Season4ExpectedPriceDefault:string,
  Season5ExpectedPriceDefault:string,
  Season6ExpectedPriceDefault:string,
  checked?: boolean

  Season1Dynamic: boolean,
  Season2Dynamic: boolean,
  Season3Dynamic: boolean,
  Season4Dynamic: boolean,
  Season5Dynamic: boolean,
  Season6Dynamic: boolean,
  Season1Ceiling: string,
  Season2Ceiling: string,
  Season3Ceiling: string,
  Season4Ceiling: string,
  Season5Ceiling: string,
  Season6Ceiling: string,

}

export function ConvertToAuditStd_StandardAuditProperties(p:Property):AuditStd_StandardAuditProperties{
let rtn = {
  checked: true,
  Address: p.PropertyAddress,
  AmadeusChainCode: p.AmadeusChainCode,
  AmadeusPropCode: p.AmadeusPropCode,
  ApolloChainCode: p.ApolloChainCode,
  ApolloPropCode: p.ApolloPropCode,
  AuditPropertyID: null,
  City: p.PropertyCity,
  ContactEMail: p.ContactEMail,
  ContactName: p.ContactName,
  CountryCode: p.PropertyCountry,
  CurrencyFormatCode: p.RateCurrency,
  CurrencyFormatID: null,
  GalileoChainCode: p.GalileoChainCode,
  GalileoPropCode: p.GalileoPropCode,
  HotelCRSCode: p.HotelCRSPropertyCode,
  Name: p.PropertyName,
  PostalCode: p.PropertyPostalCode,
  SabreChainCode: p.SabreChainCode,
  SabrePropCode: p.SabrePropCode,
  Season1EndDate: p.Season1EndDate ,
  Season1ExpectedPrice: (p.Season1ExpectedPrice!="")? Number(p.Season1ExpectedPrice).valueOf():null,
  Season1StartDate: new Date(p.Season1StartDate),
  Season2EndDate: p.Season2EndDate,
  Season2ExpectedPrice: (p.Season2ExpectedPrice!="")?Number(p.Season2ExpectedPrice).valueOf():null,
  Season2StartDate: p.Season2StartDate,
  Season3EndDate: p.Season3EndDate,
  Season3ExpectedPrice: (p.Season3ExpectedPrice!="")?Number(p.Season3ExpectedPrice).valueOf():null,
  Season3StartDate: p.Season3StartDate,
  Season4EndDate: p.Season4EndDate,
  Season4ExpectedPrice: (p.Season4ExpectedPrice!="")?Number(p.Season4ExpectedPrice).valueOf():null,
  Season4StartDate: p.Season4StartDate,
  Season5EndDate: p.Season5EndDate,
  Season5ExpectedPrice: (p.Season5ExpectedPrice!="")?Number(p.Season5ExpectedPrice).valueOf():null,
  Season5StartDate: p.Season5StartDate,
  Season6EndDate: p.Season6EndDate,
  Season6ExpectedPrice: (p.Season6ExpectedPrice!="")?Number(p.Season6ExpectedPrice).valueOf():null,
  Season6StartDate: p.Season6StartDate,
  StateProvince: p.PropertyStateProvince,
  WorldspanChainCode: p.WorldspanChainCode,
  WorldspanPropCode: p.WorldspanPropCode,

  Season1StartDateString: null,
  Season1EndDateString: null,
  Season2StartDateString: null,
  Season2EndDateString: null,
  Season3StartDateString: null,
  Season3EndDateString: null,
  Season4StartDateString: null,
  Season4EndDateString: null,
  Season5StartDateString: null,
  Season5EndDateString: null,
  Season6StartDateString: null,
  Season6EndDateString: null,

  Season1StartDateCST: null,
  Season1EndDateCST: null,
  Season2StartDateCST: null,
  Season2EndDateCST: null,
  Season3StartDateCST: null,
  Season3EndDateCST: null,
  Season4StartDateCST: null,
  Season4EndDateCST: null,
  Season5StartDateCST: null,
  Season5EndDateCST: null,
  Season6StartDateCST: null,
  Season6EndDateCST: null,

  Season1ExpectedPriceDefault: null,
  Season2ExpectedPriceDefault: null,
  Season3ExpectedPriceDefault: null,
  Season4ExpectedPriceDefault: null,
  Season5ExpectedPriceDefault: null,
  Season6ExpectedPriceDefault: null,
  Season1Dynamic: p.Season1Dynamic,
  Season2Dynamic: p.Season2Dynamic,
  Season3Dynamic: p.Season3Dynamic,
  Season4Dynamic: p.Season4Dynamic,
  Season5Dynamic: p.Season5Dynamic,
  Season6Dynamic: p.Season6Dynamic,

  Season1Ceiling: p.Season1Ceiling==""?null:p.Season1Ceiling,
  Season2Ceiling: p.Season2Ceiling==""?null:p.Season2Ceiling,
  Season3Ceiling: p.Season3Ceiling==""?null:p.Season3Ceiling,
  Season4Ceiling: p.Season4Ceiling==""?null:p.Season4Ceiling,
  Season5Ceiling: p.Season5Ceiling==""?null:p.Season5Ceiling,
  Season6Ceiling: p.Season6Ceiling==""?null:p.Season6Ceiling,

}
  return rtn;
}
